module.exports = __webpack_public_path__ + "img/pre-order-badge.c6844d9.svg";